module.exports = __webpack_public_path__ + "img/2.681de5cc.png";